import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Alert from '@mui/material/Alert';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Container from '@mui/material/Container';
import FormControlLabel from '@mui/material/FormControlLabel';
import Link from '@mui/material/Link';
import Snackbar from '@mui/material/Snackbar';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTE_PATHS } from '../routes/Routes';
import { REDIRECT_PATH_AFTER_LOGIN } from '../utility/consts';
import { queryClient } from '../services/react-query/queryClient';
import { queryKeys } from '../services/react-query/queryKeys';
import axios from '../utility/customAxios';
import {
  authContainerStyling,
  authFormHeaderStyling,
  authFormPrimaryContainerStyling,
  authFormSecondaryContainerStyling,
  authHeaderContainerStyling,
  authHeaderTypographyStyling,
  authLogoStyling,
  authSecondaryContainerStyling,
  externalFormStyling,
} from '../styles/sxStyling';

function Copyright(props: any) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://www.linkedin.com/in/nvojvodic/">
        NV
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const SignIn: React.FC = () => {
  const navigate = useNavigate();
  const [error, setError] = React.useState(null);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    axios
      .post(`login`, data)
      .then(() => {
        const redirectPath = sessionStorage.getItem(REDIRECT_PATH_AFTER_LOGIN) || ROUTE_PATHS.DASHBOARD;

        // remove record from session storage
        sessionStorage.removeItem(REDIRECT_PATH_AFTER_LOGIN);

        navigate(redirectPath);

        // refetch current user
        queryClient.invalidateQueries({ queryKey: [queryKeys.currentUser] });
        queryClient.invalidateQueries({ queryKey: [queryKeys.currentUserSettings] });
      })
      .catch((error) => {
        const response = error.response;
        if (response.status == 400) {
          setError(response.data.error);
        } else {
          Promise.reject(error);
        }
      });
  };

  return (
    <Container component="main" maxWidth="md" sx={authContainerStyling}>
      <title>ScheduLink | Studio Management Software for Volume Photo Studios</title>
      <Box sx={authSecondaryContainerStyling}>
        <Box sx={authHeaderContainerStyling}>
          <Typography variant="h1" sx={authHeaderTypographyStyling}>
            Let’s pick up where you left off
          </Typography>
          <Box component="img" src="/svg/schedulink-logo-white.svg" alt="logo" sx={authLogoStyling} />
        </Box>
        <Box sx={authFormPrimaryContainerStyling}>
          <Box sx={authFormSecondaryContainerStyling}>
            <Box sx={authFormHeaderStyling}>
              <Avatar sx={{ m: 1, bgcolor: 'primary.light' }}>
                <LockOutlinedIcon />
              </Avatar>
              <Typography component="h1" variant="h5">
                Log in
              </Typography>
            </Box>
            <Box component="form" onSubmit={handleSubmit} noValidate sx={externalFormStyling}>
              <TextField required id="email" label="Email Address" name="email" autoComplete="email" autoFocus />
              <TextField required name="password" label="Password" type="password" id="password" autoComplete="current-password" />
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <FormControlLabel control={<Checkbox value="remember" color="primary" />} label="Remember me" />
                <Link href="/forgot-password" variant="body2">
                  Forgot password?
                </Link>
              </Box>
              <Box>
                <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
                  Log in
                </Button>
                <Typography sx={{ color: 'text.secondary', fontSize: '12px' }}>
                  By logging in, you agree to ScheduLink’s Terms of Service and Privacy Statement
                </Typography>
              </Box>
            </Box>
          </Box>
          <Copyright />
        </Box>
      </Box>
      <Snackbar open={!!error} onClose={() => setError(null)} message={error}>
        <Alert severity="error" sx={{ width: '100%' }}>
          {error}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default SignIn;
